import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Svg from './Svg';

class Icon extends Component {
    shouldComponentUpdate() {
        return false;
    }

    render() {
        const { name, className, size, fill } = this.props;
        const SvgIcon = Svg[name];

        return (
            <span className={`kbe-icon ${className}`}>
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 25 25" width={size} height={size} fill={fill}>
                    <SvgIcon />
                </svg>
            </span>
        );
    }
}

Icon.defaultProps = {
    className : '',
    size      : '24',
    fill      : 'rgba(0, 0, 0, .54)',
};

Icon.propTypes = {
    name      : PropTypes.string.isRequired,
    className : PropTypes.string,
    size      : PropTypes.string,
    fill      : PropTypes.string,
};

export default Icon;
